/**
 * 应用领域数据源
 * 包含各个应用领域的完整信息和相关产品
 */

export const applications = [
  {
    id: 'security',
    name: '智能安防',
    description: '专业的智能安防芯片和解决方案，支持多种安防应用。我们的智能安防产品系列包括视频处理芯片、人脸识别芯片、运动检测芯片和报警控制芯片。',
    image: 'https://via.placeholder.com/600x400/005eb8/ffffff?text=Security+System',
    products: [
      {
        id: 1,
        name: '智能安防主控芯片',
        model: 'WX-5000',
        brand: '水芯',
        packaging: 'BGA-272',
        platform: 'ARM Cortex-A53',
        specification: '4核 1.2GHz',
        features: '人脸识别',
        process: '28nm',
        temperature: '-40~85°C',
        description: '专为安防应用设计的高性能主控芯片，集成视频处理引擎和AI加速单元',
        price: '89.50',
        image: 'https://via.placeholder.com/280x200/4A90E2/ffffff?text=WX-5000'
      },
      {
        id: 2,
        name: '智能安防视频处理芯片',
        model: 'WX-3300',
        brand: '水芯',
        packaging: 'BGA-196',
        platform: 'Media Processor',
        specification: '1080p@60fps',
        features: '视频编解码',
        process: '40nm',
        temperature: '-40~85°C',
        description: '高效的视频编解码芯片，支持H.264和H.265编码',
        price: '65.00',
        image: 'https://via.placeholder.com/280x200/1E88E5/ffffff?text=WX-3300'
      },
      {
        id: 3,
        name: '低功耗防盗报警芯片',
        model: 'WX-8800',
        brand: '水芯',
        packaging: 'QFN-64',
        platform: 'MCU ARM M4',
        specification: '32bit@80MHz',
        features: '低功耗',
        process: '55nm',
        temperature: '-20~70°C',
        description: '集成报警控制和传感器接口的低功耗微控制器',
        price: '15.80',
        image: 'https://via.placeholder.com/280x200/42A5F5/ffffff?text=WX-8800'
      }
    ]
  },
  {
    id: 'hvac',
    name: '暖通空调',
    description: '高效的空调控制芯片和管理解决方案。我们的暖通空调产品包括温度控制芯片、制冷管理IC、风机驱动芯片和能效管理芯片。',
    image: 'https://via.placeholder.com/600x400/1976D2/ffffff?text=HVAC+System',
    products: [
      {
        id: 4,
        name: '空调温度控制芯片',
        model: 'WX-3300',
        brand: '水芯',
        packaging: 'QFN-80',
        platform: 'ARM Cortex-M0+',
        specification: '32bit@48MHz',
        features: '温度控制',
        process: '45nm',
        temperature: '-20~80°C',
        description: '精准的温度控制和PID算法支持，适用于各类空调系统',
        price: '32.50',
        image: 'https://via.placeholder.com/280x200/1E88E5/ffffff?text=WX-3300'
      },
      {
        id: 5,
        name: '制冷压缩机管理芯片',
        model: 'WX-7000',
        brand: '水芯',
        packaging: 'BGA-144',
        platform: 'Specialized DSP',
        specification: '3相变频驱动',
        features: '能效优化',
        process: '40nm',
        temperature: '-20~85°C',
        description: '高效的变频驱动控制芯片，支持多种压缩机类型',
        price: '125.00',
        image: 'https://via.placeholder.com/280x200/1565C0/ffffff?text=WX-7000'
      },
      {
        id: 6,
        name: '风机驱动控制芯片',
        model: 'WX-2200',
        brand: '水芯',
        packaging: 'QFN-48',
        platform: 'MCU ARM M0',
        specification: '32bit@40MHz',
        features: '电机控制',
        process: '55nm',
        temperature: '-20~70°C',
        description: '集成功率输出级的电机驱动芯片，支持多速度控制',
        price: '24.30',
        image: 'https://via.placeholder.com/280x200/1976D2/ffffff?text=WX-2200'
      }
    ]
  },
  {
    id: 'smart-meter',
    name: '智能电表',
    description: '电力计量和管理的智能化解决方案。智能电表芯片组提供精确的电能计量、远程抄表、费率控制和需求管理功能。',
    image: 'https://via.placeholder.com/600x400/0D47A1/ffffff?text=Smart+Meter',
    products: [
      {
        id: 7,
        name: '三相智能电能表芯片',
        model: 'WX-5000',
        brand: '水芯',
        packaging: 'BGA-196',
        platform: 'ARM Cortex-A8',
        specification: '3相4线 65A',
        features: '多费率',
        process: '40nm',
        temperature: '-25~70°C',
        description: '三相四线制电能计量芯片，集成RTC和多种通信接口',
        price: '156.00',
        image: 'https://via.placeholder.com/280x200/0D47A1/ffffff?text=WX-5000'
      },
      {
        id: 8,
        name: '单相智能电能表芯片',
        model: 'WX-4500',
        brand: '水芯',
        packaging: 'BGA-144',
        platform: 'ARM Cortex-M4',
        specification: '单相3线 40A',
        features: '防篡改',
        process: '40nm',
        temperature: '-25~70°C',
        description: '单相电能计量芯片，支持防篡改和远程抄表功能',
        price: '78.50',
        image: 'https://via.placeholder.com/280x200/0D47A1/ffffff?text=WX-4500'
      },
      {
        id: 9,
        name: '电表通信模块芯片',
        model: 'WX-6600',
        brand: '水芯',
        packaging: 'QFN-80',
        platform: 'RF/ModemProcessor',
        specification: '315/433/868MHz',
        features: '无线通信',
        process: '45nm',
        temperature: '-25~70°C',
        description: '集成射频收发器的无线通信模块芯片，支持多种频段',
        price: '42.80',
        image: 'https://via.placeholder.com/280x200/0D47A1/ffffff?text=WX-6600'
      }
    ]
  }
]

export const applicationAreas = applications.map(app => ({
  id: app.id,
  icon: app.id === 'security' ? '🔒' : app.id === 'hvac' ? '❄️' : '⚡',
  name: app.name,
  description: app.description,
  image: app.image,
  backgroundColor: app.id === 'security' ? '#E3F2FD' : app.id === 'hvac' ? '#E1F5FE' : '#E0F2F1'
}))

export const getApplicationById = (id) => {
  return applications.find(app => app.id === id)
}

export default {
  applications,
  applicationAreas,
  getApplicationById
}
